
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";

interface DuplicateNameDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

export const DuplicateNameDialog = ({ isOpen, onClose }: DuplicateNameDialogProps) => {
  return (
    <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent className="p-6">
        <AlertDialogHeader>
          <AlertDialogTitle>Duplicate Guest Name</AlertDialogTitle>
          <AlertDialogDescription>
            That name has already been invited to the event. If they're inviting a guest with the same name, make sure the names are distinguishable (i.e. John D and John F, or something similar).
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="mt-6">
          <Button onClick={onClose}>
            Got it
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
